import React from "react";
import Head from "next/head";
import { SITE_NAME } from "../../../config/seo";
import { IMetaProps } from "./types";

/**
 * Component should be used to provide necessary meta data of the page.
 * To know more checkout the types.d.ts
 * */
const Meta: React.FC<IMetaProps> = ({
  title,
  description,
  canonicalUrl,
  ogImage,
  ogTitle,
  ogDescription,
  children,
  siteName = SITE_NAME,
}) => {
  return (
    <Head>
      <title>
        {title} | {siteName}
      </title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={`${ogTitle || title} | ${siteName}`} />
      <meta property="og:description" content={ogDescription || description} />
      {!!ogImage && <meta property="og:image" content={ogImage} />}
      {/* twitter tags */}
      <meta property="twitter:url" content={canonicalUrl} />
      <meta
        name="twitter:title"
        content={`${ogTitle || title} | ${siteName}`}
      />
      <meta name="twitter:description" content={ogDescription || description} />
      {!!ogImage && <meta name="twitter:image" content={ogImage} />}
      {children}
    </Head>
  );
};

export default Meta;
export type { IMetaProps };
